<template>
  <div class="batch_plants">
    <vs-card id="archieve_plants">
      <div class="vx-row mb-2">
        <div class="vx-col w-full flex items-end justify-between">
          <div class="inline-block">
            <span>
              <b>Batch Name: &nbsp;</b> <span>{{ batch && batch.batch_name }}</span>
            </span>
            <br />
            <span>
              <b>Batch Number: &nbsp;</b> <span>{{ batch && batch.batch_number }}</span>
            </span>
          </div>
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col w-full">
          <vs-table
            class="vs-con-loading__container"
            stripe
            :sst="true"
            maxHeight="500px"
            @search="updateSearchQuery"
            @change-page="handleChangePage"
            @sort="handleSort"
            :total="FilteredCount"
            pagination
            :max-items="length"
            search
            :data="archievePlants"
          >
            <template slot="header">
              <!-- TABLE ACTION ROW -->
              <div class="flex flex-wrap justify-between items-center">
                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                  <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                      <span class="mr-2">
                        {{ page * length - (length - (FilteredCount && 1)) }}
                        -
                        {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                        of {{ FilteredCount }} (filtered from {{ total }} total entries)
                      </span>
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="handleChangeLength(10)">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(20)">
                        <span>20</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(50)">
                        <span>50</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(100)">
                        <span>100</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th sort-key="batch_plant.plant_name">Sr#</vs-th>
              <vs-th sort-key="batch_plant.plant_name">Plant Name</vs-th>
              <vs-th sort-key="batch_plant.serialNumber">Serial Number</vs-th>
              <vs-th sort-key="location.name">Location</vs-th>
              <vs-th sort-key="batch_plant.plant_stage">Plant stage</vs-th>
              <vs-th>Plant Weight</vs-th>
              <vs-th>Date</vs-th>
              <vs-th>User</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }" ref="tableBody">
              <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
                <!-- strain name -->
                <vs-td>
                  {{ page * length - (length - i - 1) }}
                </vs-td>

                <!-- plant name -->
                <vs-td>
                  {{ tr.plant_name }}
                </vs-td>

                <!-- serial name -->
                <vs-td>
                  {{ tr.serialNumber }}
                </vs-td>

                <!-- location -->
                <vs-td>
                  <span v-if="!tr.inlineEdit">{{ tr.location && tr.location.name }}</span>
                  <select-2
                    v-if="tr.inlineEdit"
                    class="w-full"
                    ref="locationList"
                    :value="locationId"
                    @input="(item) => (locationId = item && item.value)"
                    label-placeholder="Location"
                    name="Location"
                    placeholder="Select Location"
                    newLabel="Add New Location"
                    @addNew="
                      () => {
                        isAddLocationModalShow = true
                      }
                    "
                    label="name"
                    :ssr="true"
                    :params="{ dropdownLocationId: locationId }"
                    action="location/fetchLocations"
                    v-validate="'required'"
                  />
                </vs-td>

                <!-- growth phase -->
                <vs-td>{{ renderPlantStage(tr.plant_stage) }}</vs-td>

                <!-- plant weight -->
                <vs-td> {{ calculatePlantWeight(tr) }} lbs </vs-td>

                <!-- date -->
                <vs-td>
                  {{ formatDate(tr.destroy_date) }}
                </vs-td>

                <!-- user -->
                <vs-td>
                  {{ tr.user.business_name }}
                </vs-td>
                <vs-td>
                  <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="p-4 border border-solid d-theme-border-grey-light cursor-pointer flex items-center justify-between font-medium">
                      Actions
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu class="archieved_plants_actions">
                      <!--Restore batch plant -->
                      <vs-dropdown-item @click="toggleBatchRestorePlants(tr)">Restore Batch Plant </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vs-card>

    <!--Restore batch plants -->
    <restore-batch-plants v-if="isRestoreBatchPlantsModalMounted" :isModalShow.sync="isRestoreBatchPlantsModalShow" :batchId="Number($route.params.batchId)" @done="getArchieveBatchPlants" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { weightMixins } from '@/utils/weightType'
import { plantStages } from '@/utils/batch-options'
import { dateMixins } from '@/mixins/dateMixins.js'
import RestoreBatchPlants from '@/views/batches/components/modals/plants/RestoreBatchPlants'

export default {
  name: 'BatchPlants',

  components: {
    Select2,
    RestoreBatchPlants
  },

  data() {
    return {
      loading: false,
      order: [],
      length: 15,
      page: 1,
      search: '',
      archievePlants: [],

      // batch information
      batch: null,

      // change restore batch plants
      isRestoreBatchPlantsModalMounted: false,
      isRestoreBatchPlantsModalShow: false
    }
  },

  mixins: [weightMixins, dateMixins],

  mounted() {
    // get archive best plant list
    this.getArchieveBatchPlants()

    // get batch by id
    this.getBatchById()
  },

  computed: {
    ...mapState('batch', {
      FilteredCount(state) {
        return state['archived-plant-FilteredCount']
      },
      plants(state) {
        return state['archived-plant-plants']
      },
      total(state) {
        return state['archived-plant-total']
      }
    }),
    ...mapState('permission', ['permissions']),
    ...mapState('auth', ['parentUser']),
    ...mapGetters('auth', ['checkPermissionByIds']),

    calculatePlantWeight() {
      return (data) => {
        return (data.harvestedPlant || []).reduce((acc, item) => {
          if (data.id === item.plantId) {
            acc += this.convertAvailableQty(item.quantity, item.weight_type)['Pounds']
          }

          return acc
        }, 0)
      }
    },

    renderPlantStage() {
      return (plantStage) => {
        return (plantStages.find((x) => x.value === plantStage) || {}).label
      }
    }
  },

  methods: {
    ...mapMutations('batch', ['SET_STATE']),

    async getBatchById() {
      const { batchId } = this.$route.params
      this.processing = true
      this.$store
        .dispatch('batch/get', batchId)
        .then(({ data }) => {
          this.processing = false
          this.batch = data.batch
        })
        .catch((err) => {
          const { message } = err
          this.processing = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    //restore batch plants
    toggleBatchRestorePlants(data) {
      this.selectedBatch = data
      this.isRestoreBatchPlantsModalMounted = true
      this.isRestoreBatchPlantsModalShow = true
    },

    // get archieve batch plant
    getArchieveBatchPlants() {
      this.loading = true
      this.$store
        .dispatch('batch/getBatchPlants', {
          id: this.$route.params.batchId,
          data: {
            page: this.page,
            search: this.search,
            limit: this.length,
            order: this.order,
            status: 'active',
            plantStages: ['sold', 'destroyed']
          },
          list: 'archived-plant'
        })
        .then((res) => {
          this.archievePlants = res.data
          this.loading = false
        })
        .catch(({ message }) => {
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getArchieveBatchPlants()
    },

    handleChangePage(page) {
      this.page = page
      this.getArchieveBatchPlants()
    },

    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getArchieveBatchPlants()
    },

    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getArchieveBatchPlants()
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#archieve_plants',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#archieve_plants > .con-vs-loading')
      }
    },

    processing() {
      if (this.processing) {
        this.$vs.loading({
          container: '#archieve_plants',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#archieve_plants > .con-vs-loading')
      }
    },

    // handle callback for restore batch plants
    isRestoreBatchPlantsModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isRestoreBatchPlantsModalMounted = false
            this.selectedBatch = null
          }, 0)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.archieved_plants_actions {
  width: 250px;
  li {
    padding: 5px;
    a {
      display: flex !important;
      font-weight: bold;
      align-items: center;
    }
  }
}
</style>

<style lang="scss">
#archieve_plants {
  position: relative;

  .con-vs-loading {
    position: absolute;
  }
}
.vs-dropdown--item:hover .vs-dropdown--item-link {
  font-weight: 700;
}
</style>
